import { render, staticRenderFns } from "./SJHome.vue?vue&type=template&id=96101bb2&"
import script from "./SJHome.vue?vue&type=script&lang=js&"
export * from "./SJHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports